import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { useAuth } from '../../context/AuthContext';
import { getLanguageNames } from '../../language/languages.js';
import AuthLayout from './AuthLayout';
import AuthWelcome from './AuthWelcome';
import LoginForm from './LoginForm';

const LoginPage = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const { user, loading } = useAuth();
  const [currentLanguageIndex, setCurrentLanguageIndex] = useState(0);
  
  // Available languages for cycling
  const availableLanguages = getLanguageNames();

  // Cycle through languages every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentLanguageIndex((prevIndex) => 
        (prevIndex + 1) % availableLanguages.length
      );
    }, 3000);

    return () => clearInterval(interval);
  }, [availableLanguages.length]);

  // Check if user is already logged in and redirect to fullchat
  useEffect(() => {
    if (!loading && user) {
      console.log('User already logged in, redirecting to fullchat...');
      navigate('/fullchat', { replace: true });
    }
  }, [user, loading, navigate]);

  const handleChangeLanguage = () => {
    navigate('/');
  };

  const welcomeContent = (
    <AuthWelcome
      title={
        <>
          Smart help for<br />
          small businesses<br />
          in Oakland.
        </>
      }
      subtitle={
        <>
          Speak your language.<br />
          Get answers.
        </>
      }
      showSignupLink={true}
    />
  );

  return (
    <AuthLayout
      welcomeContent={welcomeContent}
      showLanguageButton={true}
      onLanguageChange={handleChangeLanguage}
      currentLanguage={availableLanguages[currentLanguageIndex]?.name}
    >
      <LoginForm />
    </AuthLayout>
  );
};

export default LoginPage; 